import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductDetail } from "src/models/Products/Product.models";

interface ProductDetailState {
  productDetails: IProductDetail[];
  productDetailToEdit: IProductDetail | null;
}

const initialState: ProductDetailState = {
  productDetails: [],
  productDetailToEdit: null,
};

const productDetailSlice = createSlice({
  name: "ProductDetail",
  initialState,
  reducers: {
    setProductDetailList: (state, action: PayloadAction<IProductDetail[]>) => {
      state.productDetails = action.payload;
    },
    concatListProductDetail: (
      state: ProductDetailState,
      action: PayloadAction<IProductDetail[]>
    ) => {
      state.productDetails = [...state.productDetails.concat(action.payload)];
    },
  },
});

export const { setProductDetailList, concatListProductDetail } =
  productDetailSlice.actions;

export default productDetailSlice.reducer;
